export default __webpack_public_path__ + "static/media/done.dc2f52b0.png";